import { TimelinePlaybackState } from "../../../../../store/playback/types";

export const useIsItemTransitioningOut = (
  playbackState:
    | Pick<TimelinePlaybackState, "isActiveItemTransitioningOut">
    | undefined
): boolean => {
  return playbackState?.isActiveItemTransitioningOut ?? false;
};
